import React from 'react';

import { SalarySlipContext } from './SalarySlipContext';

const useSalarySlipContext = () => React.useContext(SalarySlipContext);

export { useSalarySlipContext };
